var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPreviousButtoninline = function SvgPreviousButtoninline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 18,
    viewBox: "0 0 16 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m2 9.621 13.148 8.246c.469.294.849.086.849-.466V.59c0-.552-.386-.756-.85-.466L2 8.371V.993A.994.994 0 0 0 1 0C.448 0 0 .445 0 .993v16.006c0 .549.444.993 1 .993.552 0 1-.445 1-.993V9.621z"
  })));
};
export default SvgPreviousButtoninline;